var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading",class:{ loaded: _vm.loading.loaded, hidden: _vm.loading.hidden }},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.data.title))]),_c('h3',[_vm._v("by "+_vm._s(_vm.data.info.artist.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }